import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { useIntl } from 'react-intl';

import { userHasFeature } from '../../helpers/Features';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';
import ExpirationDateDropdownPicker from '../ExpirationDateDropdown';

const ShareModalExpirationDate = ({ expirationDate, handleChangeDate }) => {
  const intl = useIntl();

  return (
    <div className="share-expire-time share-setting form-inline">
      <Label>
        <span>
          {intl.formatMessage({ defaultMessage: 'Expiration date' })}
          <HelpIcon id="share-expiration-date">
            {intl.formatMessage({ defaultMessage: 'Select a date to disable this share link and make files unaccessible.' })}
          </HelpIcon>
        </span>
      </Label>
      <div className="buttons-group">
        <UpgradePlanButton feature="share-expiration-date" simple={true} />
        {userHasFeature('share-expiration-date') && (
          <ExpirationDateDropdownPicker
            expirationDate={expirationDate}
            onChange={handleChangeDate}
          />
        )}
      </div>
    </div>
  );
};

ShareModalExpirationDate.propTypes = {
  expirationDate: PropTypes.object,
  handleChangeDate: PropTypes.func.isRequired,
};

ShareModalExpirationDate.defaultProps = {
  expirationDate: null,
};

export default ShareModalExpirationDate;
